import React from "react";
import { Helmet } from "react-helmet";
// import { useTranslation } from "react-i18next";

import "./style.scss";
import { Media, MediaContextProvider } from "../../media";


function DeliveryDestination(props) {

  return (
    <>
      <Helmet>
        <title>Delivery Destination | Lussopack</title>
        <meta name="description" content="Delivery Destination | Lussopack" />
        <meta name="keywords" content="Delivery Destination | Lussopack" />
        <link rel="canonical" href="https://lussopack.com/delivery-destination/" />  
      </Helmet>

      <MediaContextProvider>
        <Media greaterThanOrEqual="md">
        <div id="deliveryDestination">
        <h2>Delivery Destinations</h2>
        <p>At Lussopack, we have prepared our delivery services to people across the world,  therefore, we are confident to say that we offer worldwide shipping to meet the needs of our global customer base. No matter where you are located, we strive to deliver your packaging solutions right to your doorstep. Our commitment to efficient and reliable shipping ensures your orders reach you in a timely manner.</p>

        <h3>International Shipping</h3>
        <p>We offer international shipping to a wide range of countries across the globe. From North America to Europe, Asia to Australia, and everywhere in between, Lussopack is dedicated to providing our products to customers worldwide.</p>

        <h3>Shipping Costs</h3>
        <p>Shipping costs are calculated based on factors such as destination, weight, and shipping method. Our sales executive will be providing the option to select the most suitable shipping method for your needs. Rest assured, we work with trusted carriers to offer competitive shipping rates.</p>

        <h3>Shipping Times</h3>
        <p>The delivery time may vary depending on your location and the shipping method selected. Our team is committed to processing orders promptly, and we provide estimated delivery times at the time of purchase. Keep in mind that international shipments may be subject to customs clearance procedures, which can affect delivery times.</p>

        <h3>Order Tracking</h3>
        <p>For your convenience, we provide order tracking information once your shipment is dispatched. This allows you to monitor the progress of your order and receive real-time updates on its status.</p>

        <h3>Customs and Duties</h3>
        <p>Please be aware that international shipments may be subject to import duties, taxes, and customs fees, which are levied once the package reaches your country. These charges are the responsibility of the recipient and may vary from country to country. We recommend checking with your local customs office for more information on potential fees.</p>

        <h3>Contact Us</h3>
        <p>If you have any specific shipping-related inquiries or need assistance with your order, our dedicated customer support team is here to help. Please feel free to reach out to us through our email for personalized assistance.</p>



        </div>
        </Media>
        <Media lessThan="md">
        <div id="deliveryDestinationMobile">
        <h2>Delivery Destinations</h2>
        <p>At Lussopack, we have prepared our delivery services to people across the world,  therefore, we are confident to say that we offer worldwide shipping to meet the needs of our global customer base. No matter where you are located, we strive to deliver your packaging solutions right to your doorstep. Our commitment to efficient and reliable shipping ensures your orders reach you in a timely manner.</p>

        <h3>International Shipping</h3>
        <p>We offer international shipping to a wide range of countries across the globe. From North America to Europe, Asia to Australia, and everywhere in between, Lussopack is dedicated to providing our products to customers worldwide.</p>

        <h3>Shipping Costs</h3>
        <p>Shipping costs are calculated based on factors such as destination, weight, and shipping method. Our sales executive will be providing the option to select the most suitable shipping method for your needs. Rest assured, we work with trusted carriers to offer competitive shipping rates.</p>

        <h3>Shipping Times</h3>
        <p>The delivery time may vary depending on your location and the shipping method selected. Our team is committed to processing orders promptly, and we provide estimated delivery times at the time of purchase. Keep in mind that international shipments may be subject to customs clearance procedures, which can affect delivery times.</p>

        <h3>Order Tracking</h3>
        <p>For your convenience, we provide order tracking information once your shipment is dispatched. This allows you to monitor the progress of your order and receive real-time updates on its status.</p>

        <h3>Customs and Duties</h3>
        <p>Please be aware that international shipments may be subject to import duties, taxes, and customs fees, which are levied once the package reaches your country. These charges are the responsibility of the recipient and may vary from country to country. We recommend checking with your local customs office for more information on potential fees.</p>

        <h3>Contact Us</h3>
        <p>If you have any specific shipping-related inquiries or need assistance with your order, our dedicated customer support team is here to help. Please feel free to reach out to us through our email for personalized assistance.</p>
        </div>
        </Media>
      </MediaContextProvider>
    </>
  );
}

export default DeliveryDestination;
